module.exports = __webpack_public_path__ + "static/media/GlennAndersonAir_Logo.801782c9.png";